import {BaseDtoModel} from '../../Services/Models/base-model.service';

export class DocumentsReviewFilters extends BaseDtoModel {
  store_id!: number;

  constructor(dataJson?: any) {
    super(dataJson);

    this.init({
      store_id: 0,
    });
  }
}
